import { useQuery } from '@tanstack/react-query';
import { fetchOrder } from '@/lib/api';

export function useOrder(shopifyOrderId: string | number | undefined) {
  return useQuery({
    queryKey: ['order', shopifyOrderId],
    queryFn: () => fetchOrder(shopifyOrderId!),
    enabled: !!shopifyOrderId,
    staleTime: 10_000,
  });
}
